import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src"]

import { onMounted, ref } from 'vue';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'Header',
  props: {
        bgColor: String,
        logoUrl: String
    },
  setup(__props) {

const props = __props;



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "app-header p-2",
    style: _normalizeStyle({ 'backgroundColor': props.bgColor })
  }, [
    _createElementVNode("img", {
      src: props.logoUrl || '../assets/logo.png'
    }, null, 8, _hoisted_1)
  ], 4))
}
}

})